import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiLeasingOffers } from 'modules/api';
import { LeasingOfferStatus } from 'modules/types/LeasingOffer';
import { PagingParams } from 'modules/types/PagingParams';

export const fetchLeasingOffers = createAsyncThunk(
  'leasingOffers/featchLeasingOffers',
  async (
    params: PagingParams & { leasingOfferStatus?: LeasingOfferStatus },
    { rejectWithValue },
  ) => {
    try {
      const response = await ApiLeasingOffers.getLeasingOffers(params);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
